export default __webpack_public_path__ + "return.png";